import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client';
import type { ApiError } from '../types/common';

export interface SettingValue {
  value: string;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface AdminSettingsResponse {
  settings: Record<string, SettingValue>;
}

const settingsKeys = {
  all: ['admin-settings'] as const,
};

async function fetchSettings(): Promise<AdminSettingsResponse> {
  const response = await apiClient.get<AdminSettingsResponse>('/admin/settings');
  return response.data;
}

async function updateSettings(settings: Record<string, string>): Promise<{ message: string }> {
  const response = await apiClient.put('/admin/settings', settings);
  return response.data;
}

export function useAdminSettings() {
  return useQuery<AdminSettingsResponse, ApiError>({
    queryKey: settingsKeys.all,
    queryFn: fetchSettings,
    staleTime: 60 * 1000,
  });
}

export function useUpdateAdminSettings() {
  const queryClient = useQueryClient();

  return useMutation<{ message: string }, ApiError, Record<string, string>>({
    mutationFn: updateSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.all });
    },
  });
}
